import TDefaultFilterItem from '@/features/api/filters/types/TDefaultFilterItem'

const getDefaultFilterItemByKind = (
  body: TDefaultFilterItem[],
  kind: 'courses' | 'status'
): TDefaultFilterItem | null => body.find((item) => item.kind === kind) ?? null

export default getDefaultFilterItemByKind
